module.exports = __webpack_public_path__ + "img/plan-2-b7.df5a406b.png";